import { LegalFormOptions } from './enums';

export function mapLegalForm(legalForm) {
  switch (legalForm) {
    case 'SP':
      return LegalFormOptions.SP;
    case 'GP':
      return LegalFormOptions.GP;
    case 'LP':
      return LegalFormOptions.LP;
    case 'LLC':
      return LegalFormOptions.LLC;
    case 'PC':
      return LegalFormOptions.PC;
    case 'PLC':
      return LegalFormOptions.PLC;
    case 'SC':
      return LegalFormOptions.SC;
    case 'OTHER':
      return LegalFormOptions.OTHER;
    default:
      return null;
  }
}

export function reverseMapLegalForm(option) {
  switch (option) {
    case LegalFormOptions.SP:
      return 'SP';
    case LegalFormOptions.GP:
      return 'GP';
    case LegalFormOptions.LP:
      return 'LP';
    case LegalFormOptions.LLC:
      return 'LLC';
    case LegalFormOptions.PC:
      return 'PC';
    case LegalFormOptions.PLC:
      return 'PLC';
    case LegalFormOptions.SC:
      return 'SC';
    case LegalFormOptions.OTHER:
      return 'OTHER';
    default:
      return null;
  }
}
